import type { TableColumn, TableData } from '@ui/uikit/components/common/Table';

/**
 * Generates a loading data array for table skeletons with default values
 */
export const generateLoadingData = <Data extends TableData>(
  columns: TableColumn<Data>[],
  rowsCount: number,
): Data[] =>
  Array.from({ length: rowsCount }, () =>
    columns.reduce((acc, column) => {
      acc[column.name] = '' as Data[keyof Data];
      return acc;
    }, {} as Data),
  );
